import React, { useState, useEffect } from 'react'
import { formatPrice, getStatusIndex, getTime, itemNameWithAddons } from '../common/Functions';

function Order({ order, index }) {

    const [activeTab, setAvtiveTab] = useState(1);
    const [time, seTime] = useState();
    const activeIndex = getStatusIndex(order.status);

    useEffect(() => {
        seTime(getTime(order.expected_delivery_time));
        const interval = setInterval(() => {
            seTime(getTime(order.expected_delivery_time));
        }, 1000);
        return () => {
            clearInterval(interval);
        }
    }, [order])


    return (
        <div className="current-order-item">
            <div className="current-order-head active">
                <div className="serial-num">{index + 1}</div>
                <div className="order-quick-info">
                    <div className="left">
                        <span className="text-white">Order No</span>
                        <span className="text-white font-big">{order.order_id}</span>
                    </div>
                    <div className="right text-right">
                        <span className="text-white"> Bill Amount</span>
                        <span className="text-white">{formatPrice(order.gross_amount)}</span>
                    </div>
                </div>
                <span className="fa fa-caret-down"></span> <span className="fa fa-caret-right"></span>
            </div>
            <div className="order-content active">
                <ul className="order-content-tabs">
                    <li className={activeTab == 1 ? 'active' : ''} onClick={() => setAvtiveTab(1)}>Order Status</li>
                    <li className={activeTab == 2 ? 'active' : ''} onClick={() => setAvtiveTab(2)}>Order Details</li>
                </ul>

                <div className="current-order-detailed-info">
                    <div className={activeTab == 1 ? 'order-details-box active' : 'order-details-box'}>
                        {activeIndex == 1 && time != 'Completed' && <p className="font-semibold">Your order will take about {time} minutes</p>}
                        {activeIndex == 1 && time == 'Completed' && <p className="font-semibold">Your order should be ready by now</p>}
                        <div className="order-status-timeline">
                            <div className="status-box success">
                                <p>
                                    <span className="status-icon">
                                        <span className="fa fa-times"></span>
                                        <span className="fa fa-check"></span>
                                    </span>

                                    <span className="status-text">Order Placed</span>
                                </p>
                            </div>
                            {activeIndex == -1 && <div className={activeIndex == -1 ? 'status-box failed' : 'status-box'}>
                                <p>
                                    <span className="status-icon">
                                        <span className="fa fa-times"></span>
                                        <span className="fa fa-check"></span>
                                    </span>

                                    <span className="status-text">Order Rejected</span>
                                </p>
                            </div>}
                            {activeIndex != -1 && <>
                                <div className={activeIndex > 0 ? 'status-box success' : 'status-box'}>
                                    <p>
                                        <span className="status-icon">
                                            <span className="fa fa-times"></span>
                                            <span className="fa fa-check"></span>
                                        </span>

                                        <span className="status-text">Order Accepted</span>
                                    </p>
                                </div>
                                <div className={activeIndex > 1 ? 'status-box success' : 'status-box'}>
                                    <p>
                                        <span className="status-icon">
                                            <span className="fa fa-times"></span>
                                            <span className="fa fa-check"></span>
                                        </span>

                                        <span className="status-text">Food ready</span>
                                    </p>
                                </div>
                            </>}
                        </div>
                    </div>
                    <div className={activeTab == 2 ? 'order-details-box active' : 'order-details-box'}>
                        <div className="completed-order mt-25">
                            <div className="order-brief mt-10">
                                <div className="row font-semibold">
                                    <div className="col-6">Items Ordered:</div>
                                    <div className="col-6 text-right">Amount</div>
                                </div>
                                {order.order_items.map((item, index) => <div className="row mt-5" key={index}>
                                    <div className="col-6">{item.item_quantity} x {itemNameWithAddons(item)}</div>
                                    <div className="col-6 text-right">{formatPrice(item.subtotal.toFixed(2))}</div>
                                </div>)}
                                <div className="bill-calculations border-top">
                                    <div className="bill-top ">
                                        <div className="row">
                                            <div className="col-6">Item Total</div>
                                            <div className="col-6 text-right"> {formatPrice(order.net_amount)}</div>
                                        </div>
                                        {order.discount != 0 && <div className="row">
                                            <div className="col-6">Discount</div>
                                            <div className="col-6 text-right">{formatPrice(order.discount)}</div>
                                        </div>}
                                        {order.taxes && order.taxes.map((tax, index) => <div className="row" key={index}>
                                            <div className="col-6">{tax.type}</div>
                                            <div className="col-6 text-right">{formatPrice(tax.amount)}</div>
                                        </div>)}
                                    </div>
                                    <div className="grand-total-calculation ">
                                        <div className="row">
                                            <div className="col-6 font-semibold">Grand Total</div>
                                            <div className="col-6 text-right font-semibold">{formatPrice(order.gross_amount)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Order
